import { DropdownOptions } from '@components/common/formControl/dropdown';
import { IRadioButtonChipOptions } from '@components/common/formControl/radioButtonChip';
import { TAccordianDetails } from '@components/siteLeads/components/siteAddress';
import { ContractorTypeLabel } from '@components/lms/addNewSite/components/meetingDetails';

export interface IOtherInfoType {
	siteSubStage: string;
	tentativeNextVisit: Date | string;
	gluePotentialOfSite: string;
	productImages: File[];
	contractorType: string;
	contractorName: string;
	contractorPhoneNumber: string;
	homeOwnerDetails: TAccordianDetails[];
	tilingContractorDetails: TAccordianDetails[];
}

export const otherInfoInitialValues: IOtherInfoType = {
	siteSubStage: '',
	tentativeNextVisit: '',
	gluePotentialOfSite: '',
	productImages: [],
	contractorType: '',
	contractorName: '',
	contractorPhoneNumber: '',
	homeOwnerDetails: [{ id: 0, isActive: true, name: '', number: '' }],
	tilingContractorDetails: [{ id: 0, isActive: true, name: '', number: '', avg_monthly_tile_adhesive_consumption: 0 }],
};

export const siteSubStageList: DropdownOptions[] = [
	{ id: 1, value: 'Foundation/Waterproofing Work' },
	{ id: 2, value: 'Structure Construction' },
	{ id: 3, value: 'Roofing' },
	{ id: 4, value: 'Utilities Installation' },
];

export const otherContractorTypeList: IRadioButtonChipOptions[] = [
	{ id: 1, label: 'Project Supervisor', value: ContractorTypeLabel.Project_Supervisor, icon: 'icon-todo-list' },
	{ id: 2, label: 'Contractor', value: ContractorTypeLabel.Contractor, icon: 'icon-spade' },
	{ id: 3, label: 'NONE', value: ContractorTypeLabel.NONE, icon: 'icon-spade' },
];

export interface IPhoneValidationData {
	data?: {
		exists?: boolean;
	};
}
